function ngShowPopup() {
  const popup = document.getElementById("ng-popup");

  if (!popup) return;


  /* =====================================================
     SOLO HOMEPAGE
  ===================================================== */

  if (window.location.pathname !== "/") {
    popup.classList.add("hidden");
    return;
  }


  /* =====================================================
     FECHA DE FINALIZACIÓN DEL DESCUENTO

     Ecuador = UTC-5

     El beneficio del 20% deja de mostrarse:
     16 octubre 2026
     00:59 AM
     hora Ecuador

     IMPORTANTE:
     No depende de la hora del dispositivo del usuario
     para interpretar la zona horaria del corte,
     porque la fecha incluye explícitamente -05:00.
  ===================================================== */

  const DISCOUNT_END_DATE =
    new Date("2026-10-16T00:59:00-05:00").getTime();


  /* =====================================================
     ELEMENTOS
  ===================================================== */

  const form =
    popup.querySelector(".ng-popup-form");

  const submitButton =
    popup.querySelector("#ng-popup-submit");

  const discountContent =
    popup.querySelector(
      "#ng-popup-discount-content"
    );

  const noDiscountContent =
    popup.querySelector(
      "#ng-popup-no-discount-content"
    );

  const successDiscount =
    popup.querySelector(
      "#ng-popup-success-discount"
    );

  const successNoDiscount =
    popup.querySelector(
      "#ng-popup-success-no-discount"
    );

  const closeBtn =
    popup.querySelector(
      ".ng-popup-close"
    );


  /* =====================================================
     LOCAL STORAGE
  ===================================================== */

  const POPUP_CLOSED_KEY =
    "ngPopupClosed";

  const POPUP_SUBMITTED_KEY =
    "ngPopupSubmitted";


  /* =====================================================
     SABER SI EL DESCUENTO SIGUE ACTIVO
  ===================================================== */

  function ngDiscountIsActive() {
    return Date.now() < DISCOUNT_END_DATE;
  }


  /* =====================================================
     ACTUALIZAR CONTENIDO DEL POPUP SEGÚN LA FECHA
  ===================================================== */

  function ngUpdatePopupContent() {

    const discountActive =
      ngDiscountIsActive();


    /* -----------------------------------------------------
       ANTES DEL CORTE
       20% OFF + NATURESCLUB
    ----------------------------------------------------- */

    if (discountActive) {

      if (discountContent) {
        discountContent.style.display = "";
      }

      if (noDiscountContent) {
        noDiscountContent.style.display = "none";
      }

      if (submitButton) {
        submitButton.textContent =
          "¡Quiero mi 20% off!";
      }

      return;
    }


    /* -----------------------------------------------------
       DESPUÉS DEL CORTE
       SIN DESCUENTO
       SIN CÓDIGO
    ----------------------------------------------------- */

    if (discountContent) {
      discountContent.style.display = "none";
    }

    if (noDiscountContent) {
      noDiscountContent.style.display = "";
    }

    if (submitButton) {
      submitButton.textContent =
        "¡Quiero unirme!";
    }

  }


  /* =====================================================
     ACTUALIZAR AUTOMÁTICAMENTE AL LLEGAR LA HORA

     Esto permite que si alguien tiene la página abierta
     justo durante el cambio, el popup se actualice
     sin necesidad de recargar.
  ===================================================== */

  function ngScheduleDiscountEnd() {

    const remaining =
      DISCOUNT_END_DATE - Date.now();

    if (remaining <= 0) {
      ngUpdatePopupContent();
      return;
    }

    /*
      setTimeout tiene un límite máximo.
      Si la fecha estuviera muy lejos,
      volveríamos a comprobar más adelante.
    */

    const MAX_TIMEOUT =
      2147483647;

    setTimeout(
      function () {

        ngUpdatePopupContent();

        if (ngDiscountIsActive()) {
          ngScheduleDiscountEnd();
        }

      },
      Math.min(
        remaining,
        MAX_TIMEOUT
      )
    );

  }


  /* =====================================================
     APLICAR ESTADO ACTUAL
  ===================================================== */

  ngUpdatePopupContent();
  ngScheduleDiscountEnd();


  /* =====================================================
     SI YA SE SUSCRIBIÓ → NO MOSTRAR
  ===================================================== */

  if (
    localStorage.getItem(
      POPUP_SUBMITTED_KEY
    ) === "true"
  ) {

    popup.classList.add("hidden");
    return;

  }


  /* =====================================================
     SI YA CERRÓ EL POPUP → NO MOSTRAR
  ===================================================== */

  if (
    localStorage.getItem(
      POPUP_CLOSED_KEY
    ) === "true"
  ) {

    popup.classList.add("hidden");
    return;

  }


  /* =====================================================
     EVITAR DOBLE INICIALIZACIÓN
  ===================================================== */

  if (
    popup.dataset.ngPopupReady ===
    "true"
  ) {

    return;

  }

  popup.dataset.ngPopupReady =
    "true";


  /* =====================================================
     MOSTRAR DESPUÉS DE 2.5 SEGUNDOS
  ===================================================== */

  setTimeout(
    function () {

      if (
        localStorage.getItem(
          POPUP_CLOSED_KEY
        ) !== "true"
        &&
        localStorage.getItem(
          POPUP_SUBMITTED_KEY
        ) !== "true"
      ) {

        /*
          Volvemos a revisar la fecha justo
          antes de mostrar el popup.
        */

        ngUpdatePopupContent();

        popup.classList.remove(
          "hidden"
        );

      }

    },
    2500
  );


  /* =====================================================
     CERRAR ÚNICAMENTE CON LA X
  ===================================================== */

  if (
    closeBtn &&
    !closeBtn.dataset.ngBound
  ) {

    closeBtn.dataset.ngBound =
      "true";


    closeBtn.addEventListener(
      "click",
      function () {

        localStorage.setItem(
          POPUP_CLOSED_KEY,
          "true"
        );

        popup.classList.add(
          "hidden"
        );

      }
    );

  }


  /* =====================================================
     ENVÍO DEL FORMULARIO
  ===================================================== */

  if (
    form &&
    !form.dataset.ngBound
  ) {

    form.dataset.ngBound =
      "true";


    /*
      Shopify procesa el formulario
      dentro del iframe oculto.

      Esto evita:

      - recargar la página
      - redirigir al usuario
      - cerrar automáticamente el popup
    */

    form.setAttribute(
      "target",
      "ng-popup-hidden-frame"
    );


    form.addEventListener(
      "submit",
      function () {

        /*
          Revisamos la hora EXACTAMENTE
          en el momento del envío.

          Esto es importante si alguien abrió
          el popup antes de las 00:59
          pero envió el correo después.
        */

        const discountActiveAtSubmit =
          ngDiscountIsActive();


        /*
          Guardamos que el usuario
          ya realizó la suscripción.

          La próxima vez no se mostrará
          nuevamente el popup
          en este navegador.
        */

        localStorage.setItem(
          POPUP_SUBMITTED_KEY,
          "true"
        );


        if (submitButton) {

          submitButton.disabled =
            true;

          submitButton.textContent =
            "Enviando...";

        }


        setTimeout(
          function () {

            /*
              Ocultamos únicamente
              el formulario.
            */

            form.style.display =
              "none";


            /*
              Ocultamos ambos mensajes
              antes de decidir cuál mostrar.
            */

            if (successDiscount) {

              successDiscount.style.display =
                "none";

            }


            if (successNoDiscount) {

              successNoDiscount.style.display =
                "none";

            }


            /*
              Si el formulario fue enviado
              ANTES de las 00:59,
              mostramos NATURESCLUB.
            */

            if (
              discountActiveAtSubmit
            ) {

              if (successDiscount) {

                successDiscount.style.display =
                  "block";

              }

            }


            /*
              Si fue enviado DESDE
              las 00:59 en adelante,
              NO mostramos ningún código.
            */

            else {

              if (successNoDiscount) {

                successNoDiscount.style.display =
                  "block";

              }

            }


            /*
              IMPORTANTE:

              El popup permanece abierto.

              Solo se cierra cuando
              el usuario presiona la X.
            */

            popup.classList.remove(
              "hidden"
            );

          },
          500
        );

      }
    );

  }

}


/* =====================================================
   INICIALIZACIÓN
===================================================== */

document.addEventListener(
  "DOMContentLoaded",
  ngShowPopup
);


window.addEventListener(
  "load",
  ngShowPopup
);


document.addEventListener(
  "shopify:section:load",
  ngShowPopup
);